import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { EnumSpinnerLoaderPosition, SpinnerLoader } from 'shared/ui'
import { logger } from 'shared/lib'
import type {
  IResponseOneTimeBroadcast,
  IResponseRecurringBroadcastById,
} from 'entities/Broadcast/api/types'
import { BroadcastsRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useBroadcastPageContext } from 'pages/broadcasts/context/broadcastsPageContext'
import {
  BroadcastDetailOneTime,
  BroadcastDetailRecurring,
} from 'pages/broadcasts/ui/BroadcastDetail'

export const DetailBroadcast = () => {
  const { broadcastStore } = useEntitiesContext()
  const [loading, setLoading] = useState(true)
  const [broadcastResponse, setBroadcastResponse] = useState<
    IResponseOneTimeBroadcast | IResponseRecurringBroadcastById | null
  >(null)
  const { id } = useParams()
  const navigate = useNavigate()
  const broadcastPageStore = useBroadcastPageContext()

  useEffect(() => {
    if (id) {
      broadcastStore
        .getItemById(id)
        .then(({ data }) => {
          if (data) {
            setBroadcastResponse(data)
          }
        })
        .catch((e) => {
          navigate(`/${BroadcastsRoutes.root}/${BroadcastsRoutes.all}`)
          logger.error(e)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [id])

  if (loading) {
    return (
      <SpinnerLoader ariaLabel={'DetailBroadcast'} position={EnumSpinnerLoaderPosition.Absolute} />
    )
  }

  if (broadcastResponse) {
    if (broadcastResponse.status === 'draft' || broadcastResponse.status === 'scheduled') {
      navigate(`/${BroadcastsRoutes.root}/${BroadcastsRoutes.edit}/${broadcastResponse.id}`)
      return <div />
    }

    if (broadcastResponse.status !== 'recurring_template') {
      return (
        <BroadcastDetailOneTime
          broadcastResponse={broadcastResponse}
          pageLayoutStore={broadcastPageStore.pageLayoutStore}
          entities={broadcastPageStore.entities}
        />
      )
    }

    return (
      <BroadcastDetailRecurring
        broadcastResponse={broadcastResponse}
        pageLayoutStore={broadcastPageStore.pageLayoutStore}
      />
    )
  }

  return <div>Not found</div>
}
